import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import { LargeVideo } from '../../../components/branding/VideoBanner'

const Outer = styled.div`
  overflow: hidden;
  border-radius: 6px;
`

type VideoProps = {
  url?: string
}

const Video = ({ url }: VideoProps) => {
  const { md: largerThanMd } = useMediaQueryContext()
  const height = largerThanMd ? '700px' : '400px'

  return (
    <Outer>
      <LargeVideo url={url} height={height} />
    </Outer>
  )
}

export default Video
